import { createSelector } from "reselect";
import { useAppSelector } from "@/store/app/hooks";
import type { RootState } from "@/store/app/storeTypes";
import { selectActiveSparxEditorDataBundle } from "@/features/sparxsEditor/store/selectors/bundleSelectors";

export const selectActiveSparxEditorWorkingData = createSelector(
  [selectActiveSparxEditorDataBundle],
  (bundle): RootState["editor"]["sparx"]["data"] => bundle.workingData,
);

export const selectActiveSparxEditorOriginalData = createSelector(
  [selectActiveSparxEditorDataBundle],
  (bundle): RootState["editor"]["sparx"]["originalData"] => bundle.originalData,
);

export const useActiveData = (): RootState["editor"]["sparx"]["data"] => {
  return useAppSelector(selectActiveSparxEditorWorkingData);
};
